// extracted by mini-css-extract-plugin
export var actionIcon = "_ug-0";